<div class="docEditor">
  <div class="w-100 header-container d-flex align-items-center justify-content-between docEditor__header">
    @if (modele) {
    <div>
      <span class="docEditor__header__title"> {{ 'docEditor.model' | translate }} </span>
      <p>{{ modele?.description }}</p>
    </div>
    }
    @if (!modele) {
    <div>
      <span class="docEditor__header__title"> {{ 'docEditor.noModel' | translate }} </span>
    </div>
    }

    <div class="buttons__container d-flex align-items-center">
      @if (showDocExportBtn) {
      <i-button styleClass="blue me-2 text-center justify-content-center" [text]="'docEditor.export' | translate"
        [childrenItems]="exportBtnItems"></i-button>
      }

      <i-button [text]="'docEditor.textLibraryShort' | translate" [pTooltip]="'docEditor.textLibrary' | translate"
        tooltipPosition="bottom" (click)="displayParagraphes = true; getParagraphes()"
        styleClass="blue me-2"></i-button>
      <i-button [text]="'back' | translate" (click)="cancel()" styleClass="red me-2"></i-button>
      <i-button [text]="'docEditor.saveAndExit' | translate" (click)="prepareToSave()" id="button-save"
        styleClass="blue me-2"> </i-button>
    </div>
  </div>
  <div class="editor-container mt-2">
    <div class="myEditor" cdkDropList #doneList="cdkDropList" [cdkDropListConnectedTo]="LIST_IDS"
      (cdkDropListDropped)="dropped($event)">
      <i-richedit [lang]="lang" [showMergeFields]="true" [mergeFields]="mergeFields()" #document_editor></i-richedit>
    </div>
    <div className="overlay" id="popup-overlay" style="display: none"></div>
    <div id="waiting-popup" style="display: none">
      <svg className="circular" height="40" width="40">
        <circle className="circle-path" cx="25" cy="25" r="20" fill="none" strokeWidth="6" strokeMiterlimit="10" />
      </svg>
    </div>
  </div>
</div>
<p-confirmDialog #cd appendTo="body" styleClass="super-compos-modal-content confirmModal"
  [header]="'confirm' | translate" icon="bi bi-exclamation-triangle">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" [label]="'global.no' | translate" (click)="cd.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" [label]="'global.yes' | translate"
      (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>

<p-sidebar position="right" [(visible)]="showFusion" styleClass="ui-sidebar-sm" [modal]="false">
  <div class="ms-1 me-1">
    <i-title [text]="'modals.mergeFields' | translate"></i-title>
    <input type="text" class="form-control w-100 mt-3 mb-3" [(ngModel)]="searchValue" />
  </div>
  <i-accordion [hideShowAllBtn]="true">
    @for (item of fusions | keyvalue; track item; let i = $index) {
    <i-accordion-tab [showEditBtn]="false" header="{{ item.key }}" class="box" cdkDropList [attr.id]="'todoList' + i"
      [cdkDropListData]="item.value" [cdkDropListConnectedTo]="[doneList]">
      <div class="mergeFields">
        @for (text of item.value | sort: 'description' : 'ASC' | searchByKey: 'key' : searchValue; track text) {
        <div class="cell" (click)="copy($event, text)" (dblclick)="insert(text.key)" [cdkDragData]="text.key" cdkDrag>
          <div [pTooltip]="text.description ? text.description : text.key">
            <i class="bi bi-copy me-1"></i>{{ text.description ? text.description : text.key }}
          </div>
        </div>
        }
      </div>
    </i-accordion-tab>
    }
  </i-accordion>
</p-sidebar>

<p-sidebar position="right" [(visible)]="displayParagraphes" styleClass="ui-sidebar-sm" [modal]="false">
  <div class="ms-1 me-1">
    <i-title [text]="'docEditor.textLibrary' | translate"></i-title>
    <input type="text" class="form-control w-100 mt-3 mb-3" [(ngModel)]="searchValueBibli" />
  </div>
  <i-accordion [hideShowAllBtn]="true">
    @for (item of paragraphes | keyvalue; track item; let i = $index) {
    <i-accordion-tab [showEditBtn]="false" header="{{ item.key }}" class="box" cdkDropList [attr.id]="'todoList' + i"
      [cdkDropListData]="item.value" [cdkDropListConnectedTo]="[doneList]">
      <div class="mergeFields">
        @for (text of item.value | sort: 'description' : 'ASC' | searchByKey: 'description' : searchValueBibli; track
        text) {
        <div class="cell" (click)="copy($event, text)" (dblclick)="insertParagraphes(text)"
          [cdkDragData]="text.texteRtf" cdkDrag>
          <div [pTooltip]="text.texte"><i class="bi bi-copy me-1"></i>{{ text.description }}</div>
        </div>
        }
      </div>
    </i-accordion-tab>
    }
  </i-accordion>
</p-sidebar>